import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adm, apiErr } from "../../lib/adminApi";
import { PageHead, TInput, Btn, Card, Badge } from "../../components/admin/ui";

export default function AdminNetwork() {
  const [data, setData] = useState(null);
  const [adjust, setAdjust] = useState({ userId: "", delta: "", reason: "" });
  const refresh = () => adm.referrals().then(setData).catch(() => {});
  useEffect(() => { refresh(); }, []);
  if (!data) return <p className="text-white/40 font-mono text-xs">LOADING…</p>;

  const doAdjust = async () => {
    try {
      const res = await adm.adjustPoints({ userId: adjust.userId, delta: Number(adjust.delta), reason: adjust.reason });
      toast.success(`Adjusted. New balance: ${res.points} pts (audit recorded).`);
      setAdjust({ userId: "", delta: "", reason: "" });
      refresh();
    } catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div data-testid="admin-network">
      <PageHead title="Motion Network" sub="Referral program visibility. Points are internal rewards — never cash. All adjustments are audit-logged." />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
        {[["Clicks", data.totals.clicks], ["Signups", data.totals.signups], ["Verified", data.totals.verified], ["Points Issued", data.totals.pointsIssued]].map(([l, v]) => (
          <Card key={l}><p className="font-serif text-3xl text-white">{v}</p><p className="font-mono text-[8px] tracking-[0.2em] text-white/40 mt-1 uppercase">{l}</p></Card>
        ))}
      </div>

      <Card>
        <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-4">REFERRAL MEMBERS</p>
        {data.members.length === 0 && <p className="text-white/40 text-sm">No members have generated referral codes yet.</p>}
        {data.members.map((m) => (
          <div key={m.userId} className="grid grid-cols-12 gap-3 items-center py-2.5 border-t border-white/5 text-xs" data-testid={`network-member-${m.code}`}>
            <span className="col-span-4 text-white/80 truncate">{m.email}</span>
            <span className="col-span-2 font-mono text-gold">{m.code}</span>
            <span className="col-span-1 text-white/50">{m.clicks} clk</span>
            <span className="col-span-1 text-white/50">{m.signups} sup</span>
            <span className="col-span-1 text-white/50">{m.verified} ver</span>
            <span className="col-span-1 font-mono text-white/80">{m.points} pts</span>
            <button onClick={() => setAdjust({ ...adjust, userId: m.userId })}
              className="col-span-2 font-mono text-[9px] tracking-[0.15em] text-white/50 hover:text-gold text-right" data-testid={`network-adjust-${m.code}`}>
              ADJUST →
            </button>
          </div>
        ))}
      </Card>

      <Card className="mt-6">
        <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-4">POINT ADJUSTMENT (AUDITED)</p>
        <div className="grid md:grid-cols-4 gap-4 items-end">
          <TInput label="USER ID" value={adjust.userId} onChange={(v) => setAdjust({ ...adjust, userId: v })} testid="adjust-user" />
          <TInput label="DELTA (+/-)" value={adjust.delta} onChange={(v) => setAdjust({ ...adjust, delta: v })} type="number" testid="adjust-delta" />
          <TInput label="REASON" value={adjust.reason} onChange={(v) => setAdjust({ ...adjust, reason: v })} testid="adjust-reason" />
          <Btn onClick={doAdjust} testid="adjust-submit">APPLY</Btn>
        </div>
      </Card>

      <Card className="mt-6">
        <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-4">FLAGGED / SUSPICIOUS</p>
        {data.flagged.length === 0 && <p className="text-white/40 text-sm">No flagged referral activity.</p>}
        {data.flagged.map((f) => (
          <div key={f.id} className="flex flex-wrap justify-between gap-2 py-2.5 border-t border-white/5 text-xs">
            <span className="text-white/70">{f.referredEmail} <span className="text-white/30">via {f.code}</span></span>
            <span className="flex gap-2">{f.flags.map((fl) => <Badge key={fl} tone="red">{fl}</Badge>)}</span>
          </div>
        ))}
      </Card>
    </div>
  );
}
